/* jshint -W030 */

function modalDisplay(modalTrigger, modalType) {

  $(modalTrigger).click(function(e){

    e.preventDefault();
    var ypx = $(window).scrollTop();
    $('body').css({
      "position": "fixed",
      "top": -ypx,
      "width": "100%"
    });
    $(modalType).fadeIn(150);

    $('span#modal-close, div.modal-close-bg').click(function(){
      $(modalType).fadeOut(150);
      $('body').css({
        "position": "initial",
        "top": "initial",
        "width": "initial"
      });
      $(window).scrollTop(ypx);
    });


    if (modalTrigger === 'circle.modal-trigger') {
      var circleClass = 'modal-' + $(this).attr('class').split(" ")[1];
      $('.m-modal-content').hide();
      $('.' + circleClass).show();
    }

    if (modalTrigger === 'a.modal-trigger-contact') {
      $('.textillate').textillate({
        in: {
          effect: "bounceInDown"
        },
        out: {
          effect: "bounceOutUp"
        }
      });
    }

  });

}

$(function(){
  modalDisplay('circle.modal-trigger', '.m-modal');
});

$(function(){
  modalDisplay('a.modal-trigger-contact', '.m-modal-contact');
});
